import { useMonitor } from '../use-monitor';

export function useMonitorUserSingleSelectorLoad() {
  return useMonitor('user-single-selector-load');
}
